import React from 'react';

import { VirtualConnectionTableColumnsByIdQueryVariables, VirtualConnectionTableColumnsByIdQuery, ColumnsByTableIdFragment, ColumnSortOrder,
  VirtualConnectionTableColumnsByIdDocument
} from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  FeatureFlagsContext,
  filterOutNullAndUndefined,
  getMaxDownstreamDatasources,
  getMaxDownstreamWorkbooks,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper,
  SelectionProviderChildProps,
} from '../../../data-catalog-shared';
import { ColumnsValidSortFields } from '../sorting/sortProviders/ColumnsGridSortProvider';
import { VirtualConnectionTableColumnsDisplayGrid, VirtualConnectionTableColumnsGridRowData } from './VirtualConnectionTableColumnsDisplayGrid';

export type QueryVariables = VirtualConnectionTableColumnsByIdQueryVariables;
export type QueryResults = VirtualConnectionTableColumnsByIdQuery;
export type QueryResultListNode = ColumnsByTableIdFragment;
export type GridRowData = VirtualConnectionTableColumnsGridRowData;

export type VirtualConnectionTableColumnsQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<ColumnsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0] &&
    resultData.virtualConnectionTables[0].columnsConnection;
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
}

function mapResultNode(
  node: QueryResultListNode,
  resultData: QueryResults,
): GridRowData {
  const virtualConnectionTables = selectMaxCountsResult(resultData);

  return {
    ...node,
    labels: node.upstreamColumns ? filterOutNullAndUndefined(node.upstreamColumns).flatMap(t => t.labels) : undefined,
    virtualConnectionTableId: resultData.virtualConnectionTables[0].vizportalUrlId,
    maxDownstreamDatasources: getMaxDownstreamDatasources(virtualConnectionTables),
    maxDownstreamWorkbooks: getMaxDownstreamWorkbooks(virtualConnectionTables),
  };
}

export function VirtualConnectionTableColumnsQueryGrid(props: VirtualConnectionTableColumnsQueryGridProps): JSX.Element {
  const { customSensitivityLabelsEnabled } = React.useContext(FeatureFlagsContext);
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableColumnsByIdDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as unknown as ColumnSortOrder,
        customSensitivityLabelsEnabled
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) => (
        <VirtualConnectionTableColumnsDisplayGrid
          rowStore={rowStore}
          selectedKeys={props.selectedKeys}
          updateSelectionForKey={props.updateSelectionForKey}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}

